/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticeHandsHips3 from '../../images/characters/apprenticeHandsHips3.png';
import apprenticeArmsFolded2 from '../../images/characters/apprenticeArmsFolded2.png';
import apprenticesBackToBack from '../../images/characters/apprenticesBackToBack.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';
import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import saraTwistHandsOutHeyhey from '../../images/characters/sara_twist_hands_out_heyhey.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';
import ianPointingLeft from '../../images/characters/ian_pointing_left.png';
import ianPointingDown from '../../images/characters/ian_pointing_down.png';
import saraSmile from '../../images/characters/sara_smile.png';
import saraHumph from '../../images/characters/sara_humph.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';
import ianSide from '../../images/characters/ian_side.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_groupDrawing.md';
import markdownFileLevel2a from './level2a_popcornJoys.md';
import markdownFileLevel2b from './level2b_wasteMath.md';
import markdownFileLevel2c from './level2c_eatMeFirstSign.md';
import markdownFileLevel3a from './level3a_sortingGame.md';
import markdownFileLevel3b from './level3b_foodScrapsRap.md';
import markdownFileLevel4a from './level4a_lunchAnalysis.md';
import markdownFileLevel4b from './level4b_collectiveImpactMath.md';
import markdownFileLevel4c from './level4c_wasteFreeLunchPoster.md';
import markdownFileLevel5a from './level5a_buySmartCode.md';
import markdownFileLevel5b from './level5b_skit.md';
import markdownFileLevel6 from './level6_biomimicry.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2a': { md: new MarkdownScript(markdownFileLevel2a) },
  '2b': { md: new MarkdownScript(markdownFileLevel2b) },
  '2c': { md: new MarkdownScript(markdownFileLevel2c) },
  '3a': { md: new MarkdownScript(markdownFileLevel3a) },
  '3b': { md: new MarkdownScript(markdownFileLevel3b) },
  '4a': { md: new MarkdownScript(markdownFileLevel4a) },
  '4b': { md: new MarkdownScript(markdownFileLevel4b) },
  '4c': { md: new MarkdownScript(markdownFileLevel4c) },
  '5a': { md: new MarkdownScript(markdownFileLevel5a) },
  '5b': { md: new MarkdownScript(markdownFileLevel5b) },
  '6': { md: new MarkdownScript(markdownFileLevel6) }
};

export function preloadClassActivity () {
  preloader([
    esHandsOutWehey,
    ianHeadshotSmile,
    apprenticeHandsHips3,
    apprenticeArmsFolded2,
    apprenticesBackToBack,
    saraSurprised,
    saraTwistHandsOutHeyhey,
    ianPointingUp,
    ianPointingLeft,
    ianPointingDown,
    saraSmile,
    saraHumph,
    ianSaraLeanQuestioning,
    ianSide
  ]);
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'left',
      characterImage: apprenticeHandsHips3,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function introVideo (level, regionData) {
  const md = levels[level].md;
  return (
    videoSlide({
      id: 'intro-video',
      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
    })
  );
}

function instructions (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'right',
      characterImage: apprenticeArmsFolded2,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}

function scoring (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'scoring',
      characterSide: 'right',
      characterImage: apprenticesBackToBack,
      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
    })
  );
}

function level1 (regionData) { // Group drawing
  const level = '1';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Scoring */}
      {scoring(level, regionData)}

      {/* Ian and Sara Outro */}
      {videoSlide({
        id: 'wrap-up',
        notes: md.getSubSectionAsHtml('Ian and Sara Outro', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Ian and Sara Outro', 'YouTube', regionData)
      })}

    </Section>
  );
}

function level2a (regionData) { // Popcorn Joys
  const level = '2a';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level2b (regionData) { // Waste math
  const level = '2b';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro to Math Challenge */}
      {videoSlide({
        id: 'intro-video',
        notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
      })}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Question */}
      {balloonSlide({
        id: 'question',
        characterSide: 'left',
        characterImage: ianHeadshotSmile,
        notes: md.getSubSectionAsHtml('Question', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Question', 'Content', false, regionData)
      })}

      {/* Answer */}
      {balloonSlide({
        id: 'answer',
        characterSide: 'right',
        characterImage: saraSurprised,
        notes: md.getSubSectionAsHtml('Answer', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Answer', 'Content', false, regionData)
      })}

    </Section>
  );
}

function level2c (regionData) { // Eat me first box
  const level = '2c';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level3a (regionData) { // Sorting Game
  const level = '3a';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Scoring */}
      {scoring(level, regionData)}

      {/* Start the Sorting Game */}
      {balloonSlide({
        id: 'start',
        characterSide: 'right',
        characterImage: saraTwistHandsOutHeyhey,
        notes: md.getSubSectionAsHtml('Start Sorting Game', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Start Sorting Game', 'Content', false, regionData)
      })}

      {/* Results */}
      {balloonSlide({
        id: 'results',
        characterSide: 'left',
        characterImage: ianSaraLeanQuestioning,
        notes: md.getSubSectionAsHtml('Results', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Results', 'Content', false, regionData)
      })}

    </Section>
  );
}

function level3b (regionData) { // Food scraps rap
  const level = '3b';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Rap Backtrack Practice */}
      {videoSlide({
        id: 'rap-backtrack-practice',
        notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
      })}

      {/* Scoring */}
      {scoring(level, regionData)}

      {/* Rap Backtrack Perform */}
      {videoSlide({
        id: 'rap-backtrack-perform',
        notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
      })}

    </Section>
  );
}

function level4a (regionData) { // Lunch analysis
  const level = '4a';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level4b (regionData) { // Collective impact math
  const level = '4b';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Question 1 */}
      {balloonSlide({
        id: 'question-1',
        characterSide: 'left',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Question 1', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Question 1', 'Content', false, regionData)
      })}

      {/* Answer 1 */}
      {balloonSlide({
        id: 'answer-1',
        characterSide: 'right',
        characterImage: saraSmile,
        notes: md.getSubSectionAsHtml('Answer 1', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Answer 1', 'Content', false, regionData)
      })}

      {/* Question 2 */}
      {balloonSlide({
        id: 'question-2',
        characterSide: 'right',
        characterImage: ianPointingLeft,
        notes: md.getSubSectionAsHtml('Question 2', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Question 2', 'Content', false, regionData)
      })}

      {/* Answer 2 */}
      {balloonSlide({
        id: 'answer-2',
        characterSide: 'left',
        characterImage: saraHumph,
        notes: md.getSubSectionAsHtml('Answer 2', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Answer 2', 'Content', false, regionData)
      })}

      {/* Question 3 */}
      {balloonSlide({
        id: 'question-3',
        characterSide: 'left',
        characterImage: ianPointingDown,
        notes: md.getSubSectionAsHtml('Question 3', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Question 3', 'Content', false, regionData)
      })}

      {/* Answer 3 */}
      {balloonSlide({
        id: 'answer-3',
        characterSide: 'right',
        characterImage: saraSurprised,
        notes: md.getSubSectionAsHtml('Answer 3', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Answer 3', 'Content', false, regionData)
      })}

      {/* Collective Impact */}
      {balloonSlide({
        id: 'collective-impact',
        characterSide: 'right',
        characterImage: saraTwistHandsOutHeyhey,
        notes: md.getSubSectionAsHtml('Collective Impact', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Collective Impact', 'Content', false, regionData)
      })}

    </Section>
  );
}

function level4c (regionData) { // Waste-free lunch poster
  const level = '4c';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Scoring */}
      {scoring(level, regionData)}

    </Section>
  );
}

function level5a (regionData) { // Buy Smart Code
  const level = '5a';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Es Buy Smart Code */}
      {balloonSlide({
        id: 'es-buy-smart-code',
        characterSide: 'left',
        characterImage: esHandsOutWehey,
        notes: md.getSubSectionAsHtml('Es Buy Smart Code', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Es Buy Smart Code', 'Content', false, regionData)
      })}

      {/* Write your class Buy Smart Code in Mission File */}
      {balloonSlide({
        id: 'write-in-mission-file',
        characterSide: 'right',
        characterImage: saraSmile,
        notes: md.getSubSectionAsHtml('Write Class Buy Smart Code', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Write Class Buy Smart Code', 'Content', false, regionData)
      })}

    </Section>
  );
}

function level5b (regionData) { // Skit
  const level = '5b';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level6 (regionData) { // Biomimicry
  const level = '6';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Intro to Biomimicry */}
      {videoSlide({
        id: 'biomimicry-intro',
        notes: md.getSubSectionAsHtml('Intro to Biomimicry', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Intro to Biomimicry', 'YouTube', regionData)
      })}

      {/* Biomimicry Info */}
      {balloonSlide({
        id: 'biomimicry-info',
        characterSide: 'right',
        characterImage: saraHumph,
        notes: md.getSubSectionAsHtml('Biomimicry Info', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Biomimicry Info', 'Content', false, regionData)
      })}

      {/* Class Brainstorm */}
      {balloonSlide({
        id: 'class-brainstorm',
        characterSide: 'right',
        characterImage: ianSide,
        notes: md.getSubSectionAsHtml('Class Brainstorm', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Class Brainstorm', 'Content', false, regionData)
      })}

      {/* Nature Principles */}
      {balloonSlide({
        id: 'nature-principals',
        characterSide: 'right',
        characterImage: saraSurprised,
        notes: md.getSubSectionAsHtml('Nature Principles', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Nature Principles', 'Content', false, regionData)
      })}

      {/* Design a Product */}
      {balloonSlide({
        id: 'design-a-product',
        characterSide: 'right',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Design a Product', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Design a Product', 'Content', false, regionData)
      })}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1':
    return level1(regionData);
  case '2a':
    return level2a(regionData);
  case '2b':
    return level2b(regionData);
  case '2c':
    return level2c(regionData);
  case '3a':
    return level3a(regionData);
  case '3b':
    return level3b(regionData);
  case '4a':
    return level4a(regionData);
  case '4b':
    return level4b(regionData);
  case '4c':
    return level4c(regionData);
  case '5a':
    return level5a(regionData);
  case '5b':
    return level5b(regionData);
  case '6':
    return level6(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/30_classActivity/classActivitySection.jsx